export function fileProgressToHumanReadableString(progress, fileName, options) {
    const progressPercent = Math.floor(progress.percentComplete);
    const sourceString = progress.source === 'network' ? '' : progress.source === 'memcache' ? 'from cache' : 'from backup';
    let result = `Downloading file ${sourceString} "${fileName}"`;
    if (options.showPercent) {
        result += ` (${progressPercent}%)`;
    }
    return result;
}
